export const subscribe = async (email: string) => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/subscribe`;
  const strData = JSON.stringify({
    email: email
  });
  const res = await (
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: strData,
    })
  ).json();

  return res;
};

export const verifyToken = async (token: string) => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/verifyToken`;
  const strData = JSON.stringify({
    token: token
  });
  const res = await (
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: strData,
    })
  ).json();

  return res;
};